import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import type { ButtonProps } from '../../button';
import { Button } from '../../button';
import { Loader } from '../../loader';

const MIN_GAP = 20;
const LOADER_SIZE = 32;

interface LoadMoreButtonProps {
  next(): void;
  isLoading: boolean;
  gap: number;
  loaderColor?: string;
  loadMoreButton?: ButtonProps;
  text?: string;
  hasNext?: boolean;
  className?: string;
}

export function LoadMoreButton({
  className,
  hasNext,
  next,
  isLoading,
  text = 'Load More',
  gap,
  loaderColor,
  loadMoreButton,
  ...forwardingProps
}: LoadMoreButtonProps) {
  const handleClick = () => {
    if (!hasNext || isLoading) {
      return;
    }

    next();
  };

  if (!hasNext) {
    return null;
  }

  return (
    <Container
      {...forwardingProps}
      className={createReadableClass(
        {
          component: 'load-more-button',
          element: 'container'
        },
        [className]
      )}
      _offset={Math.max(gap, MIN_GAP)}
    >
      {isLoading ? (
        <Loader
          className={createReadableClass({
            component: 'load-more-button',
            element: 'loader'
          })}
          size={LOADER_SIZE}
          color={loaderColor}
        />
      ) : (
        <Button
          {...loadMoreButton}
          className={createReadableClass({ component: 'load-more-button' })}
          onClick={handleClick}
          text={text}
        />
      )}
    </Container>
  );
}

const Container = styled.div<{
  _offset: number;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ _offset }) => `${_offset}px`};
`;
